import { useEffect /*, useRef, useCallback*/ } from 'react';
// import { toast, ToastContainer } from "react-toastify";  // [TOAST] uncomment to restore floating notifications
// import { usePrevious } from "../../hooks/usePrevious";   // [TOAST] required to compare previous count
import { connect } from 'react-redux';

// import { notificationsSelectors } from '../../shared/redux/notifications/selectors'; // [TOAST] re-add when restoring toast feature
import { notificationsActions } from '../../shared';
import { authSelectors } from '../../shared/redux/auth/selectors';
import { subprojectSelectors } from '../../shared/redux/dashboard/selectors';

// import { notificationService } from "../../shared/";     // [TOAST] required to mark notification as read on click
import './notificationAlert.scss';

const NotificationAlert = (props) => {
    const { fetchNotificationsUnread, user, subprojectId } = props;
    // const notificationUnreadRef = useRef();                // [TOAST]
    // const prevNotificationCount = usePrevious(notifications?.count); // [TOAST]

    // [TOAST] Mark notification as read when the toast is clicked
    // const NotificationMarkRead = (id) => {
    //     notificationService?.markAsRead(id);
    // };

    useEffect(() => {
        fetchNotificationsUnread(subprojectId);
        const TIME_IN_SECONDS = 30;
        const interval = setInterval(() => {
            if (user) {
                fetchNotificationsUnread(subprojectId);
            }
        }, TIME_IN_SECONDS * 1000);

        return () => clearInterval(interval);
    }, [fetchNotificationsUnread, user, subprojectId]);

    // [TOAST] Floating notification logic — uncomment this entire block to restore it
    // const notificationToast = useCallback(() => {
    //     const toastConfigurations = {
    //         className: 'mt-5',
    //         position: 'top-right',
    //         autoClose: 10000,
    //         hideProgressBar: false,
    //         closeOnClick: true,
    //         pauseOnHover: true,
    //         draggable: true,
    //     };
    //     if (notifications.count > prevNotificationCount) {
    //         if (notificationUnreadRef.current) {
    //             notificationUnreadRef.current = true;
    //             toast.info(
    //                 <div>
    //                     You have {notifications.count} unread notifications. Please click
    //                     the <i className="fa fa-bell" />
    //                     {' to see them.'}
    //                 </div>,
    //                 toastConfigurations
    //             );
    //         } else {
    //             const [notificationItem = {}] = notifications.results;
    //             const type = {
    //                 success: 'check-circle',
    //                 info: 'bell',
    //                 warning: 'exclamation-triangle',
    //                 error: 'times-circle',
    //             };
    //             toast(
    //                 <div
    //                     className="custom-alert-notification"
    //                     onClick={(e) => NotificationMarkRead(notificationItem?.id)}
    //                 >
    //                     <i className={`fa fa-${type[notificationItem.level]}`} />
    //                     {` ${
    //                         notificationItem?.description
    //                             ? notificationItem?.description
    //                             : notificationItem?.verb
    //                     }`}
    //                 </div>,
    //                 {
    //                     ...toastConfigurations,
    //                     type: notificationItem.level,
    //                 }
    //             );
    //         }
    //     }
    // }, [notifications, prevNotificationCount]);
    //
    // useEffect(() => {
    //     notificationToast();
    // }, [notificationToast]);

    // Bell icon badge: this logic lives in Root.componentDidUpdate, which runs after
    // the DOM is committed and guarantees the header is present for authenticated routes.
    // (A useEffect here fires before the header mounts on the login page.)
    // useEffect(() => {
    //     const count = notifications?.count || 0;
    //     const bellIcon = document.querySelector('.header .controls .fa-bell');
    //     const bellToggle = bellIcon?.parentElement;
    //     if (bellToggle) {
    //         bellToggle.classList.add('bell-toggle');
    //         if (count > 0) {
    //             bellToggle.setAttribute('data-badge', count > 99 ? '99+' : String(count));
    //         } else {
    //             bellToggle.removeAttribute('data-badge');
    //         }
    //     }
    // }, [notifications]);

    // [TOAST] Replace `return null` with the block below to restore the ToastContainer
    // return (
    //     <div className="notication--alert--container">
    //         <ToastContainer />
    //     </div>
    // );
    return null;
};

const mapStateToProps = (store) => {
    return {
        // notifications: notificationsSelectors.getNotificationsUnread(store), // [TOAST] re-add when restoring toast feature
        user: authSelectors.getUser(store),
        subprojectId: subprojectSelectors.getSubprojectSelected(store),
    };
};

const mapDispatchToProps = (dispatch) => ({
    fetchNotificationsUnread: (subprojectId) =>
        dispatch(notificationsActions.fetchNotificationsUnread(subprojectId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationAlert);
